import { Injectable } from '@angular/core';
import { CommentSearchContent, Facet, SearchResult } from '@shared/models/search.model';
import { Domain, LocalizedKeyValue, Market } from '@shared/models/dataref.model';
import { DomainMarketLang } from '@shared/models/comments/comment.model';
import { DataRefUtils } from '@shared/utils/data-ref-utils';
import { TranslateService } from '@ngx-translate/core';
import { DisplayData, DomainMarketLangList } from '@shared/components/data-table-manager/data-table-manager.component';

@Injectable({
  providedIn: 'root',
})
export class CommentDataMapper {
  mapCommentData(
    searchResult: SearchResult<CommentSearchContent>,
    domains: Domain[],
    markets: Market[],
    commentStatuses: LocalizedKeyValue[],
    commentReasons: LocalizedKeyValue[],
    commentDomainMarketLang: DomainMarketLang,
    domainMarketLang: DomainMarketLangList,
    translateService: TranslateService
  ): {
    displayInfo: DisplayData;
    tableData: CommentSearchContent[] | undefined;
    facets: Facet[];
  } {
    const tableData = searchResult.content?.map((comment: CommentSearchContent, index) => ({
      select: false,
      domain: DataRefUtils.getLocalizedValueByKey(
        domains,
        comment.recipe?.domain,
        commentDomainMarketLang.market,
        commentDomainMarketLang.lang
      ),
      market: DataRefUtils.getLocalizedValueByKey(
        markets,
        comment.recipe?.market,
        commentDomainMarketLang.market,
        commentDomainMarketLang.lang
      ),
      language: DataRefUtils.getLocalizedValueByKey(
        domainMarketLang.languages,
        comment.recipe?.lang,
        commentDomainMarketLang.market,
        commentDomainMarketLang.lang
      ),
      content: comment.content,
      recipe: comment.recipe,
      title: comment.recipe?.title,
      status: DataRefUtils.getLocalizedValueByKey(
        commentStatuses,
        comment.status,
        commentDomainMarketLang.market,
        commentDomainMarketLang.lang
      ),
      reasons: DataRefUtils.getLocalizedValueByKey(
        commentReasons,
        comment.reasons,
        commentDomainMarketLang.market,
        commentDomainMarketLang.lang
      ),
      creationDate: comment.creationDate,
      modificationDate: comment.modificationDate,
      author: comment.creator.nickname,
      creator: comment.creator,
      identifier: comment.identifier,
      position: index,
    }));

    const displayInfo: DisplayData = {
      dataLength: searchResult.page.totalElements,
      resultsMessage: `${searchResult.page.totalElements} ${
        searchResult.page.totalElements === 1
          ? translateService.instant('COMMENTS.SEARCH.RESULT_FOUND')
          : translateService.instant('COMMENTS.SEARCH.RESULTS_FOUND')
      }`,
      noDataMessage: 'COMMENTS.SEARCH.NO_RESULT',
      totalPages: searchResult.page.totalPages,
    };

    const facets = searchResult.facets;

    return { tableData, displayInfo, facets };
  }
}
